import { render, staticRenderFns } from "./LabNews.vue?vue&type=template&id=3d808b7c&scoped=true&"
import script from "./LabNews.vue?vue&type=script&lang=js&"
export * from "./LabNews.vue?vue&type=script&lang=js&"
import style0 from "./LabNews.vue?vue&type=style&index=0&id=3d808b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d808b7c",
  null
  
)

export default component.exports